<template>
  <div v-on:click.self="closeModal" class="modal--wrapper" :class="{'modal-open': modalOpenState}">
    <div class="modal modal-forget">
      <div class="modal--title">
        <div class="modal--title-text">{{$t('tunnel.step4.verifModal.verification')}}</div>
        <div class="modal--title-actions">
          <modal-close-btn @click="closeModal"/>
        </div>
        <div class="row">
          <p>{{$t('tunnel.step4.verifModal.uSure')}}</p>
        </div>
      </div>
      <div class="modal--content" v-if="loading">
        <div class="loader">
          <loader/>
        </div>
      </div>
      <div class="modal--footer" v-else>
        <button class="card-button" @click="closeModal">{{$t('tunnel.step4.verifModal.check')}}</button>
        <button class="card-button" @click="sendRequest">{{$t('tunnel.step4.verifModal.send')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
  import ModalCloseBtn from "../../../components/modal-close-btn";
  import loader from "../../../components/loader.component";
  import {mapState} from "vuex";

  export default {
    name: "payment-verification-modal",
    components: {ModalCloseBtn, loader},
    async mounted() {
      window.addEventListener('app:payment-verification-modal.open', () => {
        this.openModal();
      });
    },
    data() {
      return {
        modalOpenState: false,
        ReqResponse: "",
      }
    },
    computed: {
      ...mapState({
        loading: s => s.client.loading,
      })
    },
    methods: {
      closeModal() {
        this.modalOpenState = false;
      },
      openModal() {
        this.modalOpenState = true;
      },
      sendRequest() {
        this.$store.commit('bookingStep4/SET_MODAL_OPEN_STATE', true);
        this.closeModal();
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/client/part/payment-verification-modal.vue